import apiClient from "./ApiService";
import { PATH_GET_USERDATA_BY_ID_TRANSACTION,PATH_POST_USERDATA } from "../config/env";

export const getUserData = async(id)=>{
    return await apiClient.get(PATH_GET_USERDATA_BY_ID_TRANSACTION+id);
}
export const saveUserData = async (data,id) => {
    console.log(data)
    return await apiClient.post(PATH_POST_USERDATA, {
        adminId: id,
        clientType: "F",
        professionDescription: data.professionName,
        professionCode: data.profession,
        maritalStatusCode: data.civilStatus,
        educationLevel: data.schooling,
        occupationCode: data.occupation,
        province: data.province,
        canton: data.canton,
        district: data.distrito,
        neighborhood: data.barrio,
        house: data.house,
        houseSide: data.houseSide,
        houseColor: data.houseColor,
        address: data.address
    });
}
